var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsNumber, IsOptional, IsString, ValidateNested, } from 'class-validator';
import { CreateVisibilityMapDto } from '../../../classes/common';
import { IsNullable } from '../../../decorators';
export class CreateConvenienceEquipmentDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateConvenienceEquipmentDto.prototype, "name", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateConvenienceEquipmentDto.prototype, "quantity", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateConvenienceEquipmentDto.prototype, "fee", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateConvenienceEquipmentDto.prototype, "exposure", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateVisibilityMapDto),
    __metadata("design:type", CreateVisibilityMapDto)
], CreateConvenienceEquipmentDto.prototype, "visibility", void 0);
__decorate([
    IsNullable(),
    IsNumber(),
    __metadata("design:type", Object)
], CreateConvenienceEquipmentDto.prototype, "minReservationPeriod", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateConvenienceEquipmentDto.prototype, "displayText", void 0);
